import { useEffect, useState } from "react";
import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { toast } from "react-toastify";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";

// You can still abstract this function elsewhere
const resetPassword = async ({ token, email, password }) => {
  const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/reset-password`;
  const response = await axios.post(apiUrl, {
    token,
    email,
    password,
  });
  return response.data;
};

export default function ResetPassword() {
  const navigate = useNavigate();
  const location = useLocation();

  const query = new URLSearchParams(location.search);
  const token = query.get("token");
  const email = query.get("email");
  console.log(email)
  console.log(token)
  const [form, setForm] = useState({
    password: "",
    confirmPassword: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const mutation = useMutation({
    mutationFn: resetPassword,
    onSuccess: () => {
      toast.success("Mot de passe réinitialisé avec succès !");
      setTimeout(() => {
        navigate("/login");
      }, 300);
    },
    onError: (error) => {
      toast.error(error.response?.data?.message || "Erreur lors de la réinitialisation !");
    },
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (form.password !== form.confirmPassword) {
      toast.error("Les mots de passe ne correspondent pas !");
      return;
    }

    if (!token || !email) {
      toast.error("Lien de réinitialisation invalide !");
      return;
    }

    mutation.mutate({
      token,
      email,
      password: form.password,
    });
  };

  return (
    <div
      className="min-h-screen w-full bg-cover bg-center flex justify-center items-center p-4"
      style={{ backgroundImage: "url('/bg.jpg')" }} // Optional: adjust if public path changes
    >
      <div className="p-8 bg-gray-200/20 border border-yellow-400 space-y-8 rounded-xl max-w-md w-full mx-auto backdrop-blur-md">
        <div className="text-center">
          <img src="/logo.jpeg" alt="Logo" className="h-24 rounded-lg shadow-md mx-auto mb-6" />
          <h2 className="text-2xl font-semibold text-white">
            Réinitialisation du Mot de Passe
          </h2>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <label htmlFor="password" className="block text-sm font-medium text-gray-50">
              Nouveau Mot de passe
            </label>
            <div className="relative">
              <input
                id="password"
                name="password"
                type={showPassword ? "text" : "password"}
                value={form.password}
                onChange={handleChange}
                className="block w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#f2c02a]"
              />
              <button
                type="button"
                className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <FaEyeSlash size={16} /> : <FaEye size={16} />}
              </button>
            </div>
          </div>

          <div className="space-y-2">
            <label htmlFor="confirmPassword" className="block text-sm font-medium text-gray-50">
              Confirmer le Mot de passe
            </label>
            <div className="relative">
              <input
                id="confirmPassword"
                name="confirmPassword"
                type={showConfirmPassword ? "text" : "password"}
                value={form.confirmPassword}
                onChange={handleChange}
                className="block w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#f2c02a]"
              />
              <button
                type="button"
                className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              >
                {showConfirmPassword ? <FaEyeSlash size={16} /> : <FaEye size={16} />}
              </button>
            </div>
          </div>

          <div className="pt-4">
            <button
              type="submit"
              className="w-full rounded-md bg-[#f2c02a] px-4 py-2 text-sm font-medium text-white hover:bg-yellow-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#f2c02a]"
              disabled={mutation.isLoading}
            >
              {mutation.isLoading ? "En cours..." : "Réinitialiser"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
